import { camelize, underscore } from 'inflected';
import { metaKey } from '~/scripts/utils';

export default async ({ $api, app, $cookies, redirect, route, store }) => {
  const customer = store.getters['user/getCustomer'];
  const coverType = store.getters['products/getCoverType'];
  const captureAmount = $cookies.get(`bonkers-ie-${coverType.product}-capture-point`);
  const code = $cookies.get(`bonkers-ie-${coverType.product}-search`);
  const searchRequired = metaKey(route, 'searchRequired');

  store.commit('pageContent/setFormStep', metaKey(route, 'formStep'));
  store.commit('order/reset', { type: 'lifeInsuranceApplication' });
  store.commit('products/setBasePath', `/${coverType.basePath}/`);

  const searchNotFound = (showError) => {
    $cookies.remove(`bonkers-ie-${coverType.product}-search`);
    let error = {};
    if (showError) {
      error = {
        flashClass: 'error',
        flashMessage: store.$i18n.t(`errors.${camelize(underscore(coverType.product), false)}SearchNotPresent`)
      };
    }
    redirect(302, app.localePath(`/${coverType.basePath}/`), error);
  };

  if (captureAmount) {
    store.commit('search/reset', { type: 'lifeInsurance' });
    coverType.product.includes('serious') ? store.commit('search/set', { illness1: captureAmount, serious_illness: true }) : store.commit('search/set', { life1: captureAmount });
    if (customer) store.commit('search/set', { dob: customer.dob });
    return;
  }

  if (!code) {
    if (searchRequired) {
      return searchNotFound(true);
    }

    let defaultSearchValuesPerProduct = {};
    switch (coverType.basePath) {
      case 'compare-income-protection-insurance':
        defaultSearchValuesPerProduct.life1 = 50000;
        break;
      case 'compare-life-insurance':
        defaultSearchValuesPerProduct.life1 = 200000;
        defaultSearchValuesPerProduct.illness1 = 50000;
        break;
      case 'compare-serious-illness-cover':
        defaultSearchValuesPerProduct.illness1 = 50000;
        defaultSearchValuesPerProduct.serious_illness = true;
        break;
    }
    store.commit('search/reset', { type: 'lifeInsurance', search: defaultSearchValuesPerProduct });
    return;
  }

  await $api(`protection/life_insurance_searches/${code}`).then(search => {
    search.plans.forEach(plan => {
      plan.quote_premium = search.best_advice_premiums[plan.code];
    });
    if (route.params.code) {
      store.commit('products/set', search.plans.find(r => r.id === route.params.code));
    }
    store.commit('products/setList', search.plans);
    if (search.user && search.user.address) {
      store.commit('utils/setAddress', search.user.address);
      delete search.user;
    }
    delete search.plans;
    store.commit('search/reset', { type: 'lifeInsurance', search });
    store.commit('search/setTemp', search);
    route.meta[0] = {
      ...route.meta[0],
      ...{ jumbotronParams: { amount: coverType.seriousIllness ? search.illness1 : search.life1, term: search.term } }
    };
  }).catch(e => {
    if (e.response.status === 403) {
      return searchNotFound();
    }
  });
};
